import { HybridServiceAccessor } from "@app/common/hybrid-service-accessor";
import { ICombinedPreferences } from "@interfaces/ICombinedPreferences";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { UserPlatform } from "@interfaces/IUser";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import copy from "fast-copy/dist/fast-copy.esm.js";
import * as moment from "moment";
//import * as rg4js from 'raygun4js';
import { PageStateNames } from "../class/PageStateNames";
import { SettingsName } from "../class/SettingsName";
import { UserPreferencesService } from "../userPreferences/service/userpreferences.service";
import { CacheService } from "./cache.Service";
import { DataCacheService } from "./caching/data-cache.service";
import { AccountOption, IAccountOptions } from "./class/AccountOption";
import { ConstantsService } from "./constantsService";
import { ILoginResponse } from "./login.service.ajs";
import { PreferencesService } from "./preferences.service";
import { WebSocketService } from "./websocket.service";

export class SessionService {

    private dataStorage = [];

    //isLoggedIn = false;
    needToCollectUserData = true;
    tokenUrl: string;

    static $inject = ["$window", "$http", "$cacheFactory", "$rootScope", "cacheService", "$q", "$log", "$state", "$mdDialog", "userPreferencesService", "webSocketService", "constantsService", "preferencesService", "$injector"];

    constructor(
        private readonly $window: angular.IWindowService,
        private readonly $http: angular.IHttpService,
        private readonly $cacheFactory: angular.ICacheFactoryService,
        private readonly $rootScope: IRunBlockRootScope,
        private readonly cacheService: CacheService,
        private readonly $q: angular.IQService,
        private readonly $log: angular.ILogService,
        private readonly $state: StateService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly userPreferencesService: UserPreferencesService,
        private readonly webSocketService: WebSocketService,
        private readonly constantsService: ConstantsService,
        private readonly preferencesService: PreferencesService,
        private readonly $injector: angular.auto.IInjectorService) {

        this.tokenUrl = this.constantsService.getTokenUrl();
        //this.isLoggedIn = !!this.getItem(SettingsName.AccessToken);

        this.refreshBuster();
    }

    hasActiveSession(): boolean {
        return !!this.getItem(SettingsName.AccessToken);
    }

    clearAllCachesAndSessions(): void {

        sessionStorage.clear();

        this.clearCustomerCacheData();
    }

    logout(force = false) {
        this.removeItem(SettingsName.AccountUserMappings);
        this.removeItem(SettingsName.AccountId);

        this.clearAllCachesAndSessions();

        this.$mdDialog.hide();

        if (!force && this.$state.transition) {
            return;
        }

        this.$state.go(PageStateNames.AUTHENTICATION_LOGIN);
    }

    setItem(key: any, value: any): void {

        key = key.toString();
        this.dataStorage[key] = value;


        if (this.isSessionStorageKey(key)) {
            this.$window.sessionStorage.setItem(key, value);
        }
    }

    getItem<T>(key: SettingsName): T {

        if (key === SettingsName.DriverVehicles_DONTUSE || key === SettingsName.Geofences_DONTUSE || key === SettingsName.ReasonCode_DONTUSE) {
            console.error("getItem no longer works for this request", key);
            //debugger;
        }

        const keyString = key.toString();

        if (this.isSessionStorageKey(key)) {
            return copy(this.$window.sessionStorage.getItem(keyString) as any);
        }

        if (!this.dataStorage[keyString]) {
            //console.error("Key", SettingsName[keyString], "doesnt exist in session storage");
            return null;
        }

        return copy(this.dataStorage[keyString]);
    }

    removeItem(key: any): void {
        key = key.toString();
        this.dataStorage[key] = null;
    }

    setStorage(result: ILoginResponse): void {
        //debugger;

        this.needToCollectUserData = false;

        // error's when changed to this._encryptopn method
        this.setItem(SettingsName.AccessToken, result.access_token);

        this.setItem(SettingsName.RefreshToken, result.refresh_token);

        this.setItem(SettingsName.LoginFail, "true");

        this.setItem(SettingsName.LastTokenAssignmentTime, moment.utc());

        //this.setItem(SettingsName.CredentialOptions_DONOTUSE, result.credentialOptions);

        //this.RequestSetting("/Settings", SettingsName.SettingsGeneral);
        //this.webSocketService.open();
    }

    shouldRefreshToken(): boolean {
        const dateLastRefreshed = this.getItem<moment.Moment>(SettingsName.LastTokenAssignmentTime);
        const rt = this.getItem(SettingsName.RefreshToken);

        //console.log("shouldRefreshToken", dateLastRefreshed?.format(), moment.utc());

        if (dateLastRefreshed && rt) {
            // Updated by CJE 29th Jan 2021 (doubled from 1 hour)
            // Actual token should expire after 4 hours
            //return dateLastRefreshed.add(20, "s").isBefore(moment.utc());
            return dateLastRefreshed.add(2, "h").isBefore(moment.utc());
        }
        else {
            return false;
        }
    }

    switchAccount(accountId: number): angular.IPromise<ILoginResponse> {
        this.clearCustomerCacheData();
        this.setItem(SettingsName.AccountId, accountId);
        return this.refreshSession(accountId, false);
    }

    switchToInternal(): angular.IPromise<ILoginResponse> {
        this.clearCustomerCacheData();
        return this.refreshSession(null, true);
    }

    refreshPromise: angular.IPromise<any> = null;
    refreshAttempts: number = 0;

    refreshSession(accountId = null, internal = false): angular.IPromise<ILoginResponse> {
        if (this.refreshPromise) {
            return this.refreshPromise;
        }

        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };

        if (accountId) {
            headers["AccountId"] = accountId;
        }

        if (internal) {
            headers["Internal"] = internal;
        }

        const rt = this.getItem(SettingsName.RefreshToken);
        this.refreshPromise = this
            .$http({
                url: this.tokenUrl,
                method: "POST",
                data: `grant_type=refresh_token&refresh_token=${rt}`,
                headers: headers
            })
            .then((response: angular.IHttpPromiseCallbackArg<ILoginResponse>) => {
                var result = response.data;

                if (result != null) {
                    if (result.access_token.length > 0) {
                        this.setStorage(result);
                    }
                }

                return result;
            })
            .catch((e: angular.IHttpResponse<any>) => {
                console.warn("Refresh session token failed", e.data, e);
                if (this.refreshAttempts >= 3) {
                    console.warn(`Refresh attempt count exceeded. Logging out.`)
                    this.logout();
                }
                else {
                    this.refreshAttempts++;
                    console.warn(`Refresh attempt failed ${this.refreshAttempts} time(s). Retrying...`)
                    this.refreshSession(accountId, internal);
                }
            })
            .finally(() => {
                this.refreshPromise = null;
                this.refreshAttempts = 0;
            });

        return this.refreshPromise;
    }

    getUserOptions(): angular.IPromise<any> {
        return this.preferencesService.getAllPreferences().then((combinedPrefs: ICombinedPreferences) => {
            this.saveUserOptions(combinedPrefs);
        });
    }

    getAccountOptions(): angular.IPromise<any> {
        return this.userPreferencesService.getAccountOptions().then(result => {
            this.saveAccountOptions(result);
        });
    }

    getAllUserAndAccountSettings() {
        const promises: any[] = [];

        promises.push(this.getUserOptions());
        if (this.$rootScope.currentUser.CurrentAccountUserMapping && this.$rootScope.currentUser.platform !== UserPlatform.Foundation) {
            promises.push(this.getAccountOptions());
        }

        return this.$q.all(promises);
    }

    toggleConfigurableDashboards(enabled = true) {
        var accountOptions = this.getItem<AccountOption>(SettingsName.AccountOptions);

        accountOptions.ConfigurableDashboards = enabled;

        this.setItem(SettingsName.AccountOptions, accountOptions);
    }

    // ---

    private saveUserOptions(userOptions: ICombinedPreferences) {
        this.setItem(SettingsName.UserOptions, userOptions);
    }

    private saveAccountOptions(accountOptions: IAccountOptions) {
        const accountOptionModel = new AccountOption(accountOptions);
        this.setItem(SettingsName.AccountOptions, accountOptionModel);

        //if (accountOptions.AccountId === 37 || accountOptions.AccountId === 6224) {
        //    this.webSocketService.open();
        //}
    }

    private isSessionStorageKey(key: number): boolean {

        // this is not good, but is the only way for now
        const isSessionKey = key == SettingsName.AccessToken || key == SettingsName.RefreshToken;

        return isSessionKey;
    }

    private refreshBuster() {

        // Sometimes we get into a weird refresh cycle, this is designed to short circuit this if we end up here
        var sessionKey = "refreshCount";
        var refreshCountString = this.$window.sessionStorage.getItem(sessionKey) || "0";
        var refreshCount = parseInt(refreshCountString);
        refreshCount++;

        if (refreshCount > 3) {
            this.$window.sessionStorage.clear();
            window.location.href = `//${window.location.host}`;
            return;
        }

        this.$window.sessionStorage.setItem(sessionKey, `${refreshCount + 1}`);

        // This allows us to clear our count AFTER we have stability
        setTimeout(() => {
            this.$window.sessionStorage.removeItem(sessionKey);
        }, 2000);
    }

    private clearCustomerCacheData() {

        if (this.webSocketService) {
            this.webSocketService.close();
        }

        const dataCacheService = new HybridServiceAccessor<DataCacheService>("dataCacheService", this.$injector);
        dataCacheService?.service?.clearAllCaches();

        this.cacheService.clearAllCaches();

        const httpCache = this.$cacheFactory.get("$http");
        httpCache.removeAll();
    }
}
